<style lang="scss" scoped>
  .collecting {
    min-height: 100px;
  }
</style>


<template>
  <div>
    <div class="collecting" v-if="collecting">
      Waiting for more data...
    </div>
    <c-sorted-table :values="values" v-else class="table">
      <thead>
        <tr>
          <th><c-sort-link name="device">Device ID</c-sort-link></th>
          <th><c-sort-link name="func">Function Code</c-sort-link></th>
          <th><c-sort-link name="register">Register</c-sort-link></th>
          <th><c-sort-link name="value">Value</c-sort-link></th>
          <th><c-sort-link name="created">Created</c-sort-link></th>
          <th><c-sort-link name="ingested">Ingested</c-sort-link></th>
        </tr>
      </thead>
      <template #body="sort">
        <tbody>
          <tr v-for="register in sort.values" :key="register.key">
            <td>{{register.device}}</td>
            <td>{{register.func}}</td>
            <td>{{register.register}}</td>
            <td>{{register.value}}</td>
            <td>{{register.created}}</td>
            <td>{{register.ingested}}</td>
          </tr>
        </tbody>
      </template>
    </c-sorted-table>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'modbus',
  props: ['diode', 'events'],
  data() {
    return {
      registers: {}
    };
  },
  computed: {
    collecting() {
      return !this.registers || Object.keys(this.registers).length === 0;
    },
    values() {
      return Object.values(this.registers);
    }
  },
  watch: {
    // clear out registers when diode changes
    diode() {
      this.$set(this, 'registers', {});
    },
    // when events change aggregate them into registers collection
    events() {
      this.events.forEach(event => {
          const register = event.payload.register;
          const func = event.payload.function;
          const device = event.payload.deviceID;
          const value = this.complement(event.payload.value);
          const hex = event.payload.value;
          const key = `${device}-${func}-${register}`;
          let created = parseInt(event.created);
          let ingested = parseInt(event.ingested);
          ingested = moment(ingested).format('YYYY-MM-DD HH:mm:ss');
          created = moment(created).format('YYYY-MM-DD HH:mm:ss');
          this.$set(this.registers, key, {device, func, register, value, hex, created, ingested});
        });
    }
  },
  methods: {
    // convert and unsigned 16 int into the 2's complement representation
    complement(value) {
      if (value >= 2**15) {
        return value - 2**16;
      }
      return value;
    }
  }
};
</script>
